import { render, staticRenderFns } from "./HomeCategory.vue?vue&type=template&id=05acbc08"
import script from "./HomeCategory.vue?vue&type=script&lang=js"
export * from "./HomeCategory.vue?vue&type=script&lang=js"
import style0 from "./HomeCategory.vue?vue&type=style&index=0&id=05acbc08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports